import { autoserializeAs } from 'cerialize';
import { isNullOrUndefined } from '../utils/util';
import { DateUtil } from '../utils/date.util';

export class AbstractLinkModel {
  @autoserializeAs(Date)
  createdDate: Date;

  @autoserializeAs(Date)
  modifiedDate: Date;

  static OnSerialized(instance: AbstractLinkModel, json: any): void {
    if (!isNullOrUndefined(instance.createdDate)) {
      json.createdDate = DateUtil.serializeDate(instance.createdDate);
    }
    if (!isNullOrUndefined(instance.modifiedDate)) {
      json.modifiedDate = DateUtil.serializeDate(instance.modifiedDate);
    }
  }

  static OnDeserialized(instance: AbstractLinkModel, json: any): void {
    if (!isNullOrUndefined(json['createdDate'])) {
      instance.createdDate = DateUtil.deserializeDate(json['createdDate']);
    }

    if (!isNullOrUndefined(json['modifiedDate'])) {
      instance.modifiedDate = DateUtil.deserializeDate(json['modifiedDate']);
    }
  }
}
